import {
  ABCampaignGoalMetric,
  ABCampaignSegments,
  ABCampaignStatus,
  ABCampaignTargetDevice
} from '@/common/model/recommend/abCampaign'

import { BadgeType } from '@/components/view/atoms/badge/Badge'

export const abCampaignStatusName = (status: ABCampaignStatus) => {
  switch (status) {
    case ABCampaignStatus.DRAFT:
      return '下書き'
    case ABCampaignStatus.RUNNING:
      return '実行中'
    case ABCampaignStatus.COMPLETED:
      return '完了'
  }
}

export const abCampaignStatusBadgeType = (status: ABCampaignStatus) => {
  switch (status) {
    case ABCampaignStatus.DRAFT:
      return BadgeType.DEFAULT
    case ABCampaignStatus.RUNNING:
      return BadgeType.SUCCESS
    case ABCampaignStatus.COMPLETED:
      return BadgeType.SECONDARY
  }
}

export const abCampaignGoalMetricName = (metric: ABCampaignGoalMetric) => {
  switch (metric) {
    case ABCampaignGoalMetric.CTR:
      return 'CTR（クリック率）'
    case ABCampaignGoalMetric.CVR:
      return 'CVR（コンバージョン率）'
  }
}

export const abCampaignTargetDeviceName = (device: ABCampaignTargetDevice) => {
  switch (device) {
    case ABCampaignTargetDevice.PC:
      return 'PC'
    case ABCampaignTargetDevice.MOBILE:
      return 'モバイル'
    case ABCampaignTargetDevice.TABLET:
      return 'タブレット'
  }
}

export const abCampaignTargetSegmentsName = (device: ABCampaignSegments) => {
  switch (device) {
    case ABCampaignSegments.ALL:
      return '全ユーザー'
    case ABCampaignSegments.MEMBERS:
      return '会員のみ'
  }
}
